const completedLessonsKey = "shuni-completed-lessons-v1";

export function readCompletedLessonIds(): Set<number> {
  try {
    const stored = JSON.parse(localStorage.getItem(completedLessonsKey) ?? "[]");
    if (!Array.isArray(stored)) return new Set();
    return new Set(
      stored.filter(
        (value): value is number =>
          Number.isInteger(value) && value > 0 && value <= 150
      )
    );
  } catch {
    return new Set();
  }
}

export function markLessonCompleted(lessonId: number) {
  const completed = readCompletedLessonIds();
  completed.add(lessonId);
  localStorage.setItem(
    completedLessonsKey,
    JSON.stringify([...completed].sort((a, b) => a - b))
  );
}

export function readLessonPosition(lessonId: number) {
  const stored = Number(localStorage.getItem(`shuni-progress-${lessonId}`));
  return Number.isFinite(stored) && stored > 0 ? stored : 0;
}
